import { ErrorBoundary } from 'shared/components/ErrorBoundary';
import { MainLayout } from 'layouts/MainLayout/MainLayout';
import NotFoundPage from 'modules/Miscellaneous/NotFoundPage';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import { privateRoutes, publicRoutes } from 'routes/constants';
import { PrivateRoute } from 'routes/PrivateRoute';

export const AppRouterConfig = createBrowserRouter(
  createRoutesFromElements(
    <>
      {publicRoutes.map(route => (
        <Route
          key={route.path}
          path={route.path}
          element={route.element}
          handle={{
            breadcrumbs: route.breadcrumbs,
          }}
          errorElement={<ErrorBoundary />}
        />
      ))}

      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        {privateRoutes.map(route => (
          <Route
            key={route.path}
            path={route.path}
            element={route.element}
            handle={{
              breadcrumbs: route.breadcrumbs,
            }}
            errorElement={<ErrorBoundary />}
          />
        ))}
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </>
  )
);
